<template>
  <v-container   v-if="is_self_route">
    <v-card>
      <v-card-title class="title style-color-main-gray">
        <v-btn
            @click="returnParent()" class="  black--text" icon small>
          <v-icon>arrow_back</v-icon>
        </v-btn>
        <span>Список записей на событие</span>
        <v-spacer></v-spacer>
        <v-tooltip bottom>
          <template v-slot:activator="{ on }">
            <v-btn v-on="on"
                   class="primary white--text" @click="loadStatistic" icon>
              <v-icon>cloud_download</v-icon>
            </v-btn>
          </template>
          <span>Скачать список записей на событие</span>
        </v-tooltip>
      </v-card-title>
      <v-data-table
          :headers="headers"
          :items="getItems"
          :loading="isLoading"
          :page.sync="pagination.page"
          :items-per-page.sync="pagination.size"
          :options.sync="options"
          :server-items-length="getCount"
          :footer-props="{'items-per-page-options':[25,50,100], 'footer-props.items-per-page-text': 'Число элементов'}"
          no-data-text="Данные отсутствуют"
          no-results-text="Ничего не было найдено"
      >
        <template v-slot:item.identifier="{ item }">
        <span @click="goChildren(item)" style="cursor: pointer;text-decoration:underline; color: #1D71B8"> {{item.lastname}} {{item.firstname}} {{item.midname}} </span>
        </template>
        <template v-slot:item.event="{ item }">
          {{item.event.name}} / {{displayDate(item.event.start_date)}}
        </template>
        <template v-slot:item.day="{ item }">
           {{displayDate(item.day)}}
        </template>
        <template v-slot:item.interval="{ item }">
          {{item.interval.started}} - {{item.interval.ended}}
        </template>
        <template v-slot:item.canceled="{ item }">
          <v-icon v-if="item.canceled">done</v-icon><v-icon v-else>clear</v-icon>
        </template>
        <template v-slot:item.is_visited="{ item }">
          <v-icon v-if="item.is_visited">done</v-icon><v-icon v-else>clear</v-icon>
        </template>
        <template v-slot:no-data>
          <v-card-text>Данные не загружены</v-card-text>
        </template>
        <template v-slot:item.btn="{ item }">
          <v-tooltip bottom>
            <template v-slot:activator="{ on }">
              <v-icon
                  @click="goChildren(item)"
                  class="mr-2"
                  medium
                  v-on="on"
              >
                account_box
              </v-icon>
            </template>
            <span>Подробнее</span>
          </v-tooltip>
          <v-tooltip bottom>
            <template v-slot:activator="{ on }">
              <v-icon
                  @click="transferRecords(item)"
                  class="mr-2"
                  medium
                  v-on="on"
              >
                calendar_month
              </v-icon>
            </template>
            <span>Перенести заявку</span>
          </v-tooltip>
        </template>
      </v-data-table>
      <EditDialog
          v-if="dialog_add_edit"
          :opened="dialog_add_edit"
          :docs_data="docs_data"
          @close="closeEditDialog"
      ></EditDialog>
    </v-card>
  </v-container>
  <router-view v-else></router-view>
</template>

<script>
import UserDataMixin from '@/mixins/UserDataMixin'
import {loadData,makeGetRequest} from "@/helper/requests";
import PaginatedDataMapperMixin from "@/mixins/PaginatedDataMapperMixin";
import urls from '@/urls/helper.js'
import names from "@/modules/recording/routers/names";
import {mapActions, mapGetters} from "vuex";
import {displayDate} from "@/helper";
import EditDialog from "@/modules/recording/page/eventAdmin/components/EditTransferDialog.vue";


export default {
  name: "List",
  components: {EditDialog},
  mixins: [
    PaginatedDataMapperMixin,
  ],

  computed: {
    ...mapGetters({
      getItems: 'records/getRecords',
      getCount: 'records/getRecordsCount',
      isLoading: 'records/isLoadingRecords',
    }),
    is_self_route: function () {
      return   this.$route.name === names.ADMINEVENTS.DETAIL
    },
  },
  data() {
    return {
      dialog_add_edit: false,
      loading: true,
      docs_data:null,
      headers: [
        {text: 'Участник', sortable: false, align: 'left', value: "identifier",},
        {text: 'Событие', sortable: false, align: 'left', value: "event",},
        {text: 'Интервал', sortable: false, align: 'left', value: "interval",},
        {text: 'Дата', sortable: false, align: 'left', value: "day",},
        {text: 'Почта', sortable: false, align: 'left', value: "email",},
        {text: 'Отменено', sortable: false, align: 'left', value: "canceled",},
        {text: 'Посещено', sortable: false, align: 'left', value: "is_visited",},
        {text: 'Код', sortable: false, align: 'left', value: "code",},
        {text: 'Действия', sortable: false, align: 'right', value: "btn",},
      ]
    }
  },
  created() {
    this.loadData();
  },
  methods: {
    displayDate,
    ...mapActions({
      loadList: 'records/loadRecordsList',
    }),
    closeEditDialog(){
      this.dialog_add_edit= false
      this.docs_data = null
      this.loadData();
    },
    transferRecords(item){
      this.dialog_add_edit= true
      this.docs_data = item
    },
    loadData(url = undefined) {
      this.loadList({
        url: url,
        event: this.$route.params.event,
        finalizer: (data, url) => {

        }
      })
    },
    returnParent() {
        this.$router.push({name: names.ADMINEVENTS._BASE})
    },
    loadStatistic(){
      makeGetRequest(
          urls.getRecordingUrlWithParameters('admin|event|records-statistic', 'get_xlsx_statistic',{ event: this.$route.params.event,})
      )
          .then(resp => {
            return resp.blob()
          }).then(data => {
        let a = document.createElement('a');
        let blob = new Blob([data], { 'type':'application/vnd.ms-excel'});
        a.href = window.URL.createObjectURL(blob);
        a.download = `Статистика.xlsx`
        a.click();
      });
    },
    goChildren(item){
      this.$router.push({name: names.ADMINEVENTS.TOKEN,params:{event: this.$route.params.event,token:item.code}})
    },
  }
}
</script>
<style scoped>
</style>
